export default __webpack_public_path__ + "static/media/twitter.cf07a6de.svg";